import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const ConfigContext = createContext();

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch configuration on mount
  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('calculation_config')
        .select('*')
        .eq('id', 1)
        .single();

      if (error) throw error;

      setConfig(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching config:', err);
      setError(err.message);
      // Fallback to hardcoded values if Supabase fails
      setConfig({
        standard_processing_fee: 1.5,
        donation_processing_fee: 1.5,
        standard_transportation: 3500,
        donation_transportation: 3500,
        rag_trader_rate: 0.3,
        value_channel_rate: 1.0,
        default_tax_rate: 20,
        default_cogs_placeholder: 8.0,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigContext.Provider value={{ config, loading, error, refetchConfig: fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
